import { cleanObject } from '@/Helpers/app';
import { createStore } from 'vuex';
import { localstoragePlugin } from './plugins/localstorage';
import { debugPlugin } from './plugins/debug';
import { busPlugin } from './plugins/bus';
import { pusherPlugin } from './plugins/pusher';
import stores from './stores';

const debug = process.env.NODE_ENV !== 'production';

const store = createStore({
  plugins: [busPlugin, debugPlugin, localstoragePlugin, pusherPlugin],
  modules: cleanObject(stores),
  strict: debug
});

export default store;
